import { useEffect, useState ,useCallback } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
  TextField,
  Grid,
  MenuItem,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  FormHelperText
} from "@mui/material";
import { fontWeight } from "@mui/system";
import { useAuth } from "../../../AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import toast styles
import {  IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';


const baseUrl = process.env.REACT_APP_API_BASE_URL;
export default function ClassTeacherForm() {
  const navigate = useNavigate();
    const { oId,userId,role,board,pId}=useAuth();
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);

   const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState('');
    const isPrincipal = role?.startsWith("PRINCIPAL") || false;
    const UserId = userId || selectedUsers;

//     const [classSectionData, setClassSectionData] = useState([]);
// const [classOptions, setClassOptions] = useState([]);
// const [sectionOptions, setSectionOptions] = useState([]);
// const [selectedClass, setSelectedClass] = useState("Class-I");
// const [selectedSection, setSelectedSection] = useState("Section-A");


const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState();
const [sscSelectedSection, setSscSelectedSection] = useState();

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
const [interSelectedClass, setInterSelectedClass] = useState();
const [interSelectedSection, setInterSelectedSection] = useState();
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");

const [sscClassSectionMap, setSscClassSectionMap] = useState({});
const [subjectOptions, setSubjectOptions] = useState([]);



//Teachers list api
useEffect(() => {
  async function fetchTeachers() {
    try {
      const response = await fetch(`${baseUrl}/api/teacherTimeTable/getAllTeachers/${oId}/TEACHER/${pId}`);
      if (response.ok) {
        const data = await response.json();
        setTeachers(data);
      } else {
        console.error("Failed to fetch teachers");
      }
    } catch (error) {
      console.error("Error fetching teachers", error);
    }
  }
  fetchTeachers();
}, [oId]);





// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
// const fetchClassRegistrationData = async () => {
//   try {
//     const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
//     const data = await response.json();

//     if (response.ok && Array.isArray(data)) {
//       // Group by class and merge section strings into unique values
//       const classSectionMap = {};

//       data.forEach(item => {
//         const className = item.classRegistration;
//         const sectionList = item.sections.split(",").map(s => s.trim());

//         if (!classSectionMap[className]) {
//           classSectionMap[className] = new Set();
//         }

//         sectionList.forEach(section => classSectionMap[className].add(section));
//       });

//       const classes = Object.keys(classSectionMap);
//       setSscClassOptions(classes); // Class dropdown options
//       setSscClassSectionMap(classSectionMap); // Save for section filtering later

//       // No default selection
//       setSscSelectedClass("");
//       setSscSelectedSection("");
//       setSscSectionOptions([]);
//     }
//   } catch (error) {
//     console.error("Error fetching SSC data:", error);
//   }
// };
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};



// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (!selectedCourseType) {
      //   setSelectedCourseType(data || "");
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};





useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here






// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);










     //select subject api 
     const fetchSubjectOptions = async () => {
      try {
        const selectedClass = sscSelectedClass || interSelectedClass;
        if (!selectedClass) return; // Fix syntax error: missing parentheses
    
        const response = await fetch(
          `${baseUrl}/api/dynamic-classReg/getAllSubjects/by-class/${pId}?classRegistration=${selectedClass}`
        );
    
        const data = await response.json();
    
        if (response.ok && Array.isArray(data) && typeof data[0] === 'string') {
          const subjectsArray = data[0].split(',').map((name, index) => ({
            id: index + 1,
            name: name.trim(),
          }));
          setSubjectOptions(subjectsArray);
        } else {
          setSubjectOptions([]);
        }
      } catch (error) {
        console.error("Error fetching subject options:", error);
        setSubjectOptions([]);
      }
    };
    
    useEffect(() => {
      if (oId && (sscSelectedClass || interSelectedClass)) {
        fetchSubjectOptions();
      }
    }, [oId, sscSelectedClass, interSelectedClass]); // Add selectedClass dependencies
    

    


    useEffect(() => {
                const fetchUsers = async () => {
                    try {
                        const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
                        if (!response.ok) {
                            // throw new Error('Failed to fetch users');
                            console.log("Failed to fetch users")
                        }
                        const data = await response.json();
                        setUsers(data);
                        if (data.length > 0) {
                          setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
                      }
                    } catch (error) {
                        console.error('Error fetching users:', error);
                    }
                };
                fetchUsers();
            }, []);
    
    


  const initialValues = {
    teacherId: "",
    teacherFirstName: "",
    teacherLastName: "",
    // teacherContactNumber: "",
    // teacherEmailId: "",
    romanNumberClass: "",
    course:"",
    sections: "",
    subject: "",
  };

  const validationSchema = Yup.object().shape({
    teacherId: Yup.string().required("Teacher is required"),
    // teacherContactNumber: Yup.string()
    //   .matches(/^[0-9]{10}$/, "Must be a valid 10-digit number")
    //   .required("Contact number is required"),
    // teacherEmailId: Yup.string()
    //   .email("Invalid email address")
    //   .required("Email is required"),
      romanNumberClass: Yup.string().required("Class name is required"),
      sections: Yup.string().required("Section is required"),
    subject: Yup.string().required("Subject is required"),
  });



  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
  
    try {
      // Creating FormData object
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key]);
      });
  
      const response = await fetch(
        `${baseUrl}/api/classTeacher/saveClassTeacher/${UserId}`,
        {
          method: "POST",
          body: formData, // Send FormData instead of JSON
        }
      );
  
      if (response.ok) {
        // toast.success("Class Teacher assigned successfully!");
        // ✅ Stop loading before toast appears
         setLoading(false);
        
        await new Promise((resolve) => {
          toast.success("Class Teacher assigned successfully!", {
            position: "top-right",
            autoClose: 1000,
            onClose: resolve, // Wait for toast to close before proceeding
          });
        });

        
        navigate(-1);
        resetForm();
      } else {
        // Get error text from response
        const errorText = await response.text();
        toast.error(errorText || "Failed to assign class teacher!");
      }
    } catch (error) {
      console.error("Error submitting form", error);
      toast.error("Error submitting the form. Please try again!");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Card sx={{   margin: "6% 1% 0% 1%",  boxShadow: 4, borderRadius: 2 }}>
       <Box display="flex" alignItems="center" sx={{marginBottom:2 ,marginTop:'10px'}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Assign Class Teacher
                              </Typography>
                            </Box>
      {/* <CardHeader title={<Typography variant="h4" sx={{fontWeight:'bold'}}>Assign Class Teacher</Typography>} /> */}
      <CardContent>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ setFieldValue, values, errors, touched ,handleBlur,handleChange}) => (
            <Form>
              <Grid container spacing={2}>
                {/* Teacher Dropdown */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="Select Teacher"
                    value={values.teacherId}
                    onChange={(e) => {
                      const selectedTeacher = teachers.find((t) => t.teacherId === e.target.value);
                      setFieldValue("teacherId", selectedTeacher?.teacherId || "");
                      setFieldValue("teacherFirstName", selectedTeacher?.teacherFirstName || "");
                      setFieldValue("teacherLastName", selectedTeacher?.teacherLastName || "");
                    }}
                    error={touched.teacherId && Boolean(errors.teacherId)}
                    helperText={touched.teacherId && errors.teacherId}
                  >
                    <MenuItem value="">Select a teacher</MenuItem>
                    {teachers.map((teacher) => (
                      <MenuItem key={teacher.teacherId} value={teacher.teacherId}>
                        {teacher.teacherFirstName} {teacher.teacherLastName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>



              
              {/* Class Name Dropdown */}
     
{board === "SSC" && (
  <>
  <Grid item xs={12} sm={6}>
   <FormControl size="medium" fullWidth>
  <InputLabel id="class-select-label">Select Class</InputLabel>
  {/* <Select
    labelId="class-select-label"
    // value={sscSelectedClass}
    // onChange={(e) => setSscSelectedClass(e.target.value)}
    label="Select Class"

    name="romanNumberClass"
    value={values.romanNumberClass}
    // onChange={(e) => {
    //   const selected = e.target.value;
    //   handleChange(e); // updates Formik state
    //   setSscSelectedClass(selected); // optional: update your component state if used elsewhere
    // }}
    onChange={(e) => {
      const selected = e.target.value;

      // ✅ Formik handleChange
      handleChange(e);

      // ✅ Your custom logic
      setSscSelectedClass(selected);
      const sections = sscClassSectionMap[selected]
        ? Array.from(sscClassSectionMap[selected])
        : [];
      setSscSectionOptions(sections);
      setSscSelectedSection(
        sections.includes("Section-A") ? "Section-A" : sections[0] || ""
      );
    }}
    onBlur={handleBlur}
  >
    {sscClassOptions.length > 0 ? (
      sscClassOptions.map((cls) => (
        <MenuItem key={cls} value={cls}>
          {cls}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No classes available</MenuItem>
    )}
  </Select> */}
  <Select
  labelId="class-select-label"
  label="Select Class"
  name="romanNumberClass"
  value={values.romanNumberClass}
  onChange={(e) => {
    const selectedClass = e.target.value;

    // ✅ Update Formik state
    handleChange(e);

    // ✅ Update your local state
    setSscSelectedClass(selectedClass);

    // ✅ Get sections for that class
    const sections = sscClassSectionMap[selectedClass]
      ? Array.from(sscClassSectionMap[selectedClass])
      : [];

    setSscSectionOptions(sections);

    // ✅ Choose default section (prefer Section-A)
    const defaultSection = sections.includes("Section-A")
      ? "Section-A"
      : sections[0] || "";

    setSscSelectedSection(defaultSection);

    // ✅ Sync with Formik
    setFieldValue("sections", defaultSection);
  }}
  onBlur={handleBlur}
>
  {sscClassOptions.length > 0 ? (
    sscClassOptions.map((cls) => (
      <MenuItem key={cls} value={cls}>
        {cls}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>No classes available</MenuItem>
  )}
</Select>

</FormControl>
</Grid>

<Grid item xs={12} sm={6}>
<FormControl size="medium" fullWidth>
  <InputLabel id="section-select-label">Select Section</InputLabel>
  {/* <Select
    labelId="section-select-label"
    // value={sscSelectedSection}
    // onChange={(e) => setSscSelectedSection(e.target.value)}
    label="Select Section"

    name="sections"
        value={values.sections}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setSscSelectedSection(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
    
  >
    {sscSectionOptions.length > 0 ? (
      sscSectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No sections available</MenuItem>
    )}
  </Select> */}
  <Select
  labelId="section-select-label"
  name="sections"
  label="Select Section"
  value={values.sections}
  onChange={(e) => {
    handleChange(e); 
    setSscSelectedSection(e.target.value);
  }}
  onBlur={handleBlur}
>
  {sscSectionOptions.length > 0 ? (
    sscSectionOptions.map((section) => (
      <MenuItem key={section} value={section}>
        {section}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>No sections available</MenuItem>
  )}
</Select>

</FormControl>
</Grid>
  </>
)}


{board === "INTERMEDIATE" && (
  <>
  <Grid item xs={12} sm={6}>
    <FormControl size="medium" fullWidth>
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        // value={interSelectedClass}
        // onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        name="romanNumberClass"
        value={values.romanNumberClass}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setInterSelectedClass(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
    <FormControl fullWidth size="medium">
  <InputLabel id="course-type-label">Select Course</InputLabel>
  <Select
    labelId="course-type-label"
    // value={selectedCourseType}

    name="course"
    value={values.course}
    onChange={(e) => {
      const selected = e.target.value;
      handleChange(e); // updates Formik state
      setSelectedCourseType(selected); // optional: update your component state if used elsewhere
    }}
    onBlur={handleBlur}

    // onChange={(e) => setSelectedCourseType(e.target.value)}
    label="Select Course"
  >
    {courseOptions.length > 0 ? (
      courseOptions.map((course, index) => (
        <MenuItem key={index} value={course}>
          {course}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No courses available</MenuItem>
    )}
  </Select>
</FormControl>
</Grid>

<Grid item xs={12} sm={6}>
    <FormControl fullWidth size="medium">
  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    // value={interSelectedSection}
    // onChange={(e) => setInterSelectedSection(e.target.value)}
    label="Select Section"

    name="sections"
        value={values.sections}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setInterSelectedSection(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
  >
    {interSectionOptions.length > 0 ? (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No sections available for selected Year and Course</MenuItem>
    )}
  </Select>
</FormControl>
</Grid>
  </>
)}






                {/* Subject Dropdown */}
          <Grid item xs={12} sm={6}>
            <FormControl
              fullWidth
              size="medium" 
              error={touched.subject && Boolean(errors.subject)}
            >
              <InputLabel>Select Subject</InputLabel>
              <Field name="subject">
                {({ field }) => (
                  <Select
                    {...field}
                    label="Select Subject"
                  >
                    {subjectOptions.length === 0 ? (
                      <MenuItem value="" disabled>
                        No subjects available
                      </MenuItem>
                    ) : (
                      subjectOptions.map((subject) => (
                        <MenuItem key={subject.id} value={subject.name}>
                          {subject.name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                )}
              </Field>
              {touched.subject && errors.subject && (
                <FormHelperText>{errors.subject}</FormHelperText>
              )}
            </FormControl>
          </Grid>



{/* Dropdown for Select User - Right Next to Date Selection */}
                      {/* {isPrincipal && (
                        <Grid item xs={12} sm={6} > 
                          <FormControl fullWidth variant="outlined" size="meddium">
                            <InputLabel>Select Schedule Admin</InputLabel>
                            <Select
                              value={selectedUsers}
                              onChange={(e) => setSelectedUsers(e.target.value)}
                              label="Select Schedule Admin"
                              // sx={{ height: "36px", display: "flex", alignItems: "center" }} // Matching height
                            >
                              {users.map((user) => (
                                <MenuItem key={user.userId} value={user.userId}>
                                  {user.userId} - {user.firstName} {user.lastName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )} */}


                {/* Submit Button */}
                <Grid item xs={12} 
                sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button 
                  type="submit" 
                  variant="contained" 
                  sx={{
                    padding: "10px 20px",
                    fontWeight:'bold',
                    backgroundColor: "#6E69B0 !important", // New green color
                    width: "140px",
                    "&:hover": {
                      backgroundColor: "#58548E !important", // Darker shade for hover
                    },
                  }} 
                   disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : "Assign Teacher"}
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
        <ToastContainer position="top-right" autoClose={1000} />
      </CardContent>
    </Card>
  );
}